/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InterrogatoryQueryCaseFile
 */
export interface InterrogatoryQueryCaseFile {
    /**
     * 
     * @type {string}
     * @memberof InterrogatoryQueryCaseFile
     */
    caseFileId: string;
}

export function InterrogatoryQueryCaseFileFromJSON(json: any): InterrogatoryQueryCaseFile {
    return InterrogatoryQueryCaseFileFromJSONTyped(json, false);
}

export function InterrogatoryQueryCaseFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): InterrogatoryQueryCaseFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'caseFileId': json['caseFileId'],
    };
}

export function InterrogatoryQueryCaseFileToJSON(value?: InterrogatoryQueryCaseFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'caseFileId': value.caseFileId,
    };
}


